<main class="book" [class.is-index-open]="c.bookIndexOpen">
  <header class="book__head">
    <button class="icon-button" type="button" matTooltip="Volver a la biblioteca" aria-label="Volver a la biblioteca" (click)="c.backToLibrary()"><mat-icon>arrow_back</mat-icon></button>
    @if (isOverlayIndex) {
      <button class="icon-button" type="button" [attr.aria-expanded]="c.bookIndexOpen" aria-controls="web-book-index" matTooltip="Índice" aria-label="Índice"
        (click)="c.toggleBookIndex()"><mat-icon>toc</mat-icon></button>
    }
    <div class="book__identity">
      @if (c.book.Portada) {<img class="book__cover" [src]="c.book.Portada | coverCache | async" alt="" (error)="c.handleCoverImageError($event)">}
      <div class="book__title">
        <strong>{{c.book.Nombre}}</strong>
        @if (authorNames) {<small>{{authorNames}}</small>}
      </div>
    </div>

    <nav class="book__tabs" aria-label="Secciones del libro">
      @for (tab of tabs; track tab.route) {
        <button type="button" [class.is-active]="isSectionActive(tab.route, tab.createRoute)" [attr.aria-current]="isSectionActive(tab.route, tab.createRoute) ? 'page' : null"
          (click)="c.navigateBookChild(tab.route)"><mat-icon aria-hidden="true">{{tab.icon}}</mat-icon>{{tab.label}}</button>
      }
    </nav>

    <div class="book__tools">
      @if (saveIndicator.isVisibleFor(c.book.Id)) {<span class="book__saved" role="status"><mat-icon aria-hidden="true">cloud_done</mat-icon>Guardado</span>}
      <button class="icon-button" type="button" matTooltip="Buscar en el libro" aria-label="Buscar en el libro"
        [class.is-active]="isSectionActive('search')" (click)="c.navigateBookChild('search')"><mat-icon>search</mat-icon></button>
      @if (c.hasBookWikiLink()) {
        <button class="icon-button" type="button" matTooltip="Abrir la wiki del libro" aria-label="Abrir la wiki del libro" (click)="c.openBookWiki()"><mat-icon>language</mat-icon></button>
      }
    </div>
  </header>

  <div class="book__body">
    @if (c.bookIndexOpen && isOverlayIndex) {<button class="book__scrim" type="button" aria-label="Cerrar índice" (click)="c.bookIndexOpen = false"></button>}
    @if (!c.bookIndexOpen && !isOverlayIndex) {
      <div class="index-rail">
        <button class="icon-button" type="button" matTooltip="Mostrar índice" matTooltipPosition="right" aria-label="Mostrar índice" aria-controls="web-book-index"
          [attr.aria-expanded]="false" (click)="c.bookIndexOpen = true"><mat-icon>last_page</mat-icon></button>
      </div>
    }
    @if (c.bookIndexOpen) {
      <nav id="web-book-index" class="index" aria-label="Índice del libro" swipeDirection="left" [swipeDisabled]="!isOverlayIndex" (appSwipeToClose)="c.bookIndexOpen = false">
        <header class="index__head">
          <strong>Índice</strong>
          @if (!isOverlayIndex) {
            <button class="icon-button icon-button--small" type="button" matTooltip="Ocultar índice" aria-label="Ocultar índice" (click)="c.bookIndexOpen = false"><mat-icon>first_page</mat-icon></button>
          } @else {
            <button class="icon-button icon-button--small" type="button" aria-label="Cerrar índice" (click)="c.bookIndexOpen = false"><mat-icon>close</mat-icon></button>
          }
        </header>
        <div class="index__actions">
          @if (!c.isBookRunning()) {
            <button class="web-button web-button--primary index__start" type="button" [disabled]="c.isSavingRunningStatus" (click)="c.startBookReading()"><mat-icon>play_arrow</mat-icon>Poner en marcha</button>
          } @else {
            <button class="chip-button" type="button" (click)="c.addChapter()" aria-label="Añadir capítulo"><mat-icon aria-hidden="true">add</mat-icon><span>Capítulo</span></button>
            <button class="chip-button" type="button" (click)="c.addPart()" aria-label="Añadir parte"><mat-icon aria-hidden="true">add</mat-icon><span>Parte</span></button>
            <button class="chip-button" type="button" (click)="c.addInterlude()" aria-label="Añadir interludio"><mat-icon aria-hidden="true">add</mat-icon><span>Interludio</span></button>
          }
        </div>

        <div class="index__scroll">
          @for (item of c.displayList; track item) {
            @if (item.type === 'chapter') {
              <ng-container *ngTemplateOutlet="chapterLink; context: { $implicit: item.data, interlude: false }"></ng-container>
            }
            @if (item.type === 'part' || item.type === 'interlude') {
              <section class="index__group" [class.index__group--interlude]="item.type === 'interlude'">
                <header>
                  <mat-icon aria-hidden="true">{{item.type === 'part' ? 'segment' : 'auto_stories'}}</mat-icon>
                  <strong>{{item.name}}</strong>
                  @if (item.type === 'interlude') {
                    <button class="icon-button icon-button--small" type="button" matTooltip="Nuevo capítulo de interludio" aria-label="Nuevo capítulo de interludio" (click)="c.addInterludeChapter(item.id)"><mat-icon>add</mat-icon></button>
                  }
                  <button class="icon-button icon-button--small" type="button" [matTooltip]="item.type === 'part' ? 'Editar parte' : 'Editar interludio'"
                    [attr.aria-label]="item.type === 'part' ? 'Editar parte' : 'Editar interludio'"
                    (click)="c.openStructureEditor(item.type === 'part' ? 'part' : 'interlude', item.id)"><mat-icon>edit</mat-icon></button>
                </header>
                @for (subItem of item.data; track subItem) {
                  @if (subItem.type === 'chapter') {
                    <ng-container *ngTemplateOutlet="chapterLink; context: { $implicit: subItem.data, interlude: item.type === 'interlude' }"></ng-container>
                  }
                  @if (subItem.type === 'interlude') {
                    <section class="index__group index__group--interlude index__group--nested">
                      <header>
                        <mat-icon aria-hidden="true">auto_stories</mat-icon>
                        <strong>{{subItem.name}}</strong>
                        <button class="icon-button icon-button--small" type="button" matTooltip="Nuevo capítulo de interludio" aria-label="Nuevo capítulo de interludio" (click)="c.addInterludeChapter(subItem.id)"><mat-icon>add</mat-icon></button>
                        <button class="icon-button icon-button--small" type="button" matTooltip="Editar interludio" aria-label="Editar interludio" (click)="c.openStructureEditor('interlude', subItem.id)"><mat-icon>edit</mat-icon></button>
                      </header>
                      @for (chapter of subItem.data; track chapter) {
                        @if (chapter.type === 'chapter') {
                          <ng-container *ngTemplateOutlet="chapterLink; context: { $implicit: chapter.data, interlude: true }"></ng-container>
                        }
                      }
                    </section>
                  }
                }
              </section>
            }
          } @empty {
            <div class="index__empty"><mat-icon aria-hidden="true">menu_book</mat-icon><p>El índice todavía está vacío.</p></div>
          }
        </div>
      </nav>
    }

    <section class="book__content">
      <app-book-router></app-book-router>
    </section>
  </div>
</main>

<ng-template #chapterLink let-chapter let-interlude="interlude">
  <button class="index__chapter" type="button" [id]="chapter.Id"
    [class.is-active]="interlude ? c.isInterludeChapterActive(chapter.Id) : c.isChapterActive(chapter.Id)"
    [attr.aria-current]="(interlude ? c.isInterludeChapterActive(chapter.Id) : c.isChapterActive(chapter.Id)) ? 'page' : null"
    (click)="interlude ? c.openInterludeChapter(chapter.Id) : c.openChapter(chapter.Id)">
    <span aria-hidden="true">{{c.getChapterOrderLabel(chapter) ?? ''}}</span>{{c.getChapterTitle(chapter)}}
  </button>
</ng-template>

@if (c.structureEditorKind) {
  <div class="dialog-scrim" (click)="c.closeStructureEditor()">
    <form class="dialog structure" role="dialog" aria-modal="true" aria-labelledby="web-structure-title" [formGroup]="c.structureForm"
      (click)="$event.stopPropagation()" (submit)="$event.preventDefault(); c.saveStructure()">
      <header class="dialog__head">
        <h2 id="web-structure-title">{{c.structureEditorKind === 'part' ? (c.editingStructureId ? 'Editar parte' : 'Nueva parte') : (c.editingStructureId ? 'Editar interludio' : 'Nuevo interludio')}}</h2>
        <button class="icon-button" type="button" aria-label="Cerrar" (click)="c.closeStructureEditor()"><mat-icon>close</mat-icon></button>
      </header>
      <div class="structure__grid">
        <mat-form-field appearance="outline" class="structure__wide">
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="nombre" (focus)="c.selectDefaultStructureName($event)">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Página</mat-label>
          <input matInput type="number" formControlName="pagina">
        </mat-form-field>
        @if (c.structureEditorKind === 'part') {
          <mat-form-field appearance="outline">
            <mat-label>Orden inicial</mat-label>
            <input matInput type="number" formControlName="ordenInicio">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Orden final</mat-label>
            <input matInput type="number" formControlName="ordenFinal">
          </mat-form-field>
        } @else {
          <mat-form-field appearance="outline">
            <mat-label>Tras el capítulo</mat-label>
            <input matInput type="number" formControlName="ordenCapituloPredecesor">
          </mat-form-field>
          <mat-form-field appearance="outline" class="structure__wide">
            <mat-label>Parte predecesora</mat-label>
            <mat-select formControlName="idPartePredecesor">
              <mat-option [value]="null">Sin parte</mat-option>
              @for (part of c.book.Partes; track part.Id) {<mat-option [value]="part.Id">{{part.Nombre}}</mat-option>}
            </mat-select>
          </mat-form-field>
        }
      </div>
      <footer class="dialog__foot">
        <button class="web-button" type="button" (click)="c.closeStructureEditor()">Cancelar</button>
        <button class="web-button web-button--primary" type="submit" [disabled]="c.structureForm.invalid">Guardar</button>
      </footer>
    </form>
  </div>
}
